import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { CompetitorsTab } from '../../components/analytics/competitors-tab';
import { useYear } from '../../hooks/use-year';

export const Route = createFileRoute('/$orgPid/analytics/competitors')({
  component: AnalyticsCompetitorsTab,
});

function AnalyticsCompetitorsTab() {
  const { boatPid } = Route.useSearch();
  const year = useYear();
  const [compSetPid, setCompSetPid] = useState('all');

  return (
    <CompetitorsTab
      year={String(year)}
      boatPid={boatPid}
      compSetPid={compSetPid}
      onCompSetPidChange={setCompSetPid}
    />
  );
}
